<template>
  <FileUpload
  :limitSizeOfMB="30"
  :acceptExtensions="fileExtensionsLimit"
  :fileQuantityLimit="fileQuantityLimit"
  listType="text"
  :fileList.sync="fileListTemp">
  </FileUpload>
</template>

<script>

import FileUpload from '@/components/FileUpload.vue';

export default {
  data() {
    return {
      fileListTemp: [],
      fileExtensionsLimit: [ // 限定哪一種檔案能上傳，空白則是不限定。(需填入小寫)
        // '.jpg',
        // '.jpeg',
        // '.png',
        // '.gif',
        // '.rar',
        // '.zip',
        // '.pdf',
      ],
    };
  },
  props: {
    fileList: Array,
    fileQuantityLimit: Number,
  },
  methods: {
  },
  computed: {
  },
  mounted() {
    // 一開始prop傳進來不會觸發watch 手動初始化
    this.fileListTemp = this.fileList;
  },
  components: {
    FileUpload,
  },
  watch: {
    fileListTemp() {
      this.$emit('update:fileList', this.fileListTemp);
    },
    fileList() {
      this.fileListTemp = this.fileList;
    },
  },
};
</script>
